import classNames from 'classnames'
import React, { useEffect, useRef, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import Cookies from 'universal-cookie'

import { ChildrenSelectList } from '@components/ChildrenSelectList'
import { ProfileInfoModal } from '@components/ProfileInfoModal'

import { useActions } from '@hooks/useActions'
import { useHeaderSetter } from '@hooks/useHeaderSetter'
import useOnClickOutside from '@hooks/useOnClickOutside'
import { useWindowSize } from '@hooks/useWindowSize'

import { api } from '@store/api'
import { useAppDispatch } from '@store/hooks'
import { useGetInfoAbutMeQuery } from '@store/profile/profile.api'

import type { UserBlockProps } from './UserBlock.props'

const userBlockData = [
  {
    iconId: 'account',
    name: 'Моя картка',
    link: '/profile',
  },
  // {
  //   iconId: 'file',
  //   name: 'Мої файли',
  //   link: '#',
  // },
  // {
  //   iconId: 'play',
  //   name: 'База знань',
  //   link: '#',
  // },
  // {
  //   iconId: 'logo',
  //   name: 'Про Unity',
  //   link: '#',
  // },
]

export function UserBlock({ ...props }: UserBlockProps) {
  const dispatch = useAppDispatch()
  const setHeaderProps = useHeaderSetter()

  const cookies = new Cookies(null, { path: '/' })

  const location = useLocation()
  const { width } = useWindowSize()

  const infoRef = useRef<HTMLDivElement>(null)

  const { data } = useGetInfoAbutMeQuery({})
  const isParent = data?.role === 10
  const isStudent = data?.role === 2

  const { setAuth } = useActions()

  const [show, setShow] = useState(false)
  const [showStudentModal, setShowStudentModal] = useState(false)

  const handleHideInfo = () => {
    setShow(false)
  }
  const handleToggleShowInfo = () => setShow((prev) => !prev)

  const handleSignOut = () => {
    setAuth(false)

    cookies.remove('accessToken')
    cookies.remove('refreshToken')

    sessionStorage.removeItem('childID') //for parents
    sessionStorage.removeItem('classID') //for teacher

    dispatch(api.util?.resetApiState())
    setHeaderProps({ type: 'custom', props: {} })
  }

  useEffect(() => {
    handleHideInfo()
  }, [location])

  useOnClickOutside(infoRef, handleHideInfo)

  return (
    <div className="header__block">
      <button
        className="header__avatar"
        onClick={handleToggleShowInfo}
        id="header-avatar"
      >
        <img
          className="header__avatar-image"
          src={data?.avatar || '/img/static/default-avatar.png'}
          alt={`${data?.last_name} ${data?.first_name}`}
        />
      </button>

      <div className={classNames('header__wrapper', { 'header__wrapper--active': show })}>
        <div
          ref={infoRef}
          className="header__info"
        >
          <div className="header__top">
            <button
              className="header__close"
              onClick={handleHideInfo}
              id="header-close"
            >
              <svg className="header__close-svg">
                <use href="/img/sprite.svg#arrow-right"></use>
              </svg>
            </button>
            <img
              className="header__top-image"
              src={data?.avatar || '/img/static/default-avatar.png'}
              alt={`${data?.last_name} ${data?.first_name}`}
            />
            <span className="header__top-name">{`${data?.last_name} ${data?.first_name}`}</span>
          </div>

          {isParent && width < 992 && <ChildrenSelectList mobile />}

          <ul className="header__list">
            {userBlockData.map((v, i) => (
              <li
                key={`${i}${v.name}`}
                className="header__item"
              >
                {v.link === '/profile' && isStudent ? (
                  <button
                    type={'button'}
                    className="header__link"
                    onClick={() => setShowStudentModal(true)}
                  >
                    <svg className="header__link-svg">
                      <use href={`/img/sprite.svg#${v.iconId}`}></use>
                    </svg>
                    {v.name}
                  </button>
                ) : (
                  <Link
                    to={v.link}
                    className="header__link"
                  >
                    <svg className="header__link-svg">
                      <use href={`/img/sprite.svg#${v.iconId}`}></use>
                    </svg>
                    {v.name}
                  </Link>
                )}
              </li>
            ))}
            <li className="header__item">
              <button
                className="header__link"
                onClick={handleSignOut}
              >
                <svg className="header__link-svg">
                  <use href="/img/sprite.svg#logout"></use>
                </svg>
                Вийти
              </button>
            </li>
          </ul>

          {/*TODO: add multi lang*/}
          {/*<LanguageSwitcher />*/}
        </div>
      </div>

      {showStudentModal && (
        <ProfileInfoModal
          onClose={() => setShowStudentModal(false)}
          studentId={data?.id}
        />
      )}
    </div>
  )
}

const langListData = [
  {
    locale: 'uk',
    name: 'Укр',
  },
  {
    locale: 'ru',
    name: 'Рус',
  },
]

function LanguageSwitcher() {
  const [lang, setLang] = useState('uk')

  return (
    <div className="header__language">
      {langListData.map((v, i) => (
        <button
          key={`${i}${v.name}`}
          className={classNames('header__lang', { 'header__lang--active': lang === v.locale })}
          onClick={() => setLang(v.locale)}
        >
          {v.name}
        </button>
      ))}
    </div>
  )
}
